import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.js';
import { createRecipe } from './create-recipe.js';

const cardDefaultVariants = {
  "variant": "default",
  "size": "md"
}
const cardCompoundVariants = [
  {
    "variant": "event",
    "size": "sm",
    "css": {
      "root": {
        "width": "220px",
        "height": "340px"
      }
    }
  },
  {
    "variant": "event",
    "size": "md",
    "css": {
      "root": {
        "width": "240px",
        "height": "340px"
      }
    }
  },
  {
    "variant": "event",
    "size": "lg",
    "css": {
      "root": {
        "width": "260px",
        "height": "420px"
      }
    }
  },
  {
    "variant": "eventDetails",
    "size": "sm",
    "css": {
      "root": {
        "width": "280px",
        "height": "480px"
      }
    }
  },
  {
    "variant": "eventDetails",
    "size": "md",
    "css": {
      "root": {
        "width": "350px",
        "height": "540px"
      }
    }
  },
  {
    "variant": "eventDetails",
    "size": "lg",
    "css": {
      "root": {
        "width": "360px",
        "height": "560px"
      }
    }
  }
]

const cardSlotNames = [
  [
    "root",
    "card__root"
  ],
  [
    "header",
    "card__header"
  ],
  [
    "body",
    "card__body"
  ],
  [
    "footer",
    "card__footer"
  ],
  [
    "title",
    "card__title"
  ],
  [
    "description",
    "card__description"
  ]
]
const cardSlotFns = /* @__PURE__ */ cardSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, cardDefaultVariants, getSlotCompoundVariant(cardCompoundVariants, slotName))])

const cardFn = memo((props = {}) => {
  return Object.fromEntries(cardSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const cardVariantKeys = [
  "variant",
  "size"
]
const getVariantProps = (variants) => ({ ...cardDefaultVariants, ...compact(variants) })

export const card = /* @__PURE__ */ Object.assign(cardFn, {
  __recipe__: false,
  __name__: 'card',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: cardVariantKeys,
  variantMap: {
  "variant": [
    "default",
    "event",
    "artist",
    "eventDetails"
  ],
  "size": [
    "sm",
    "md",
    "lg"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, cardVariantKeys)
  },
  getVariantProps
})